module.exports = __webpack_public_path__ + "static/Distilled-8ddfeaf01f81c6e6a16f90148467a876.gif";